import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

const AvatarContainer = styled.div`
  background-color: ${(props) => props.theme.colors.blue};
  border-radius: 50%;
  width: 90px;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-weight: bold;
  display: inline-block;
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => rem(props.theme.fontSizes[7])};
  flex-shrink: 0;
  margin-right: 40px;
`

const Avatar = ({ initials }) => {
  return <AvatarContainer>{initials}</AvatarContainer>
}

export default Avatar
